import { Injectable, TemplateRef } from '@angular/core';
import { Subject } from 'rxjs';

export interface IConfirmModalSettings {
  title?: string;
  confirmAction: () => any;
  rejectAction?: () => any;
  confirmText?: string;
  cancelText?: string;
  hideClose?: boolean;
  body?: TemplateRef<any> | null;
  bodyText?: string;
  validator?: () => string;
  width?: string;
}

@Injectable({
  providedIn: 'root',
})
export class ConfirmModalService {
  private $confirm = new Subject<IConfirmModalSettings>();
  public confirm = this.$confirm.asObservable();

  constructor() {}

  openConfirm(config: IConfirmModalSettings) {
    this.$confirm.next(config);
  }
}
